// Vendedores Produlimp BV — código → nombre + número WhatsApp (sin "+", sin guiones)
export const SELLERS = [
  { code: "01", name: "Daniel Martinelli", whatsapp: "5491133272896" },
  { code: "02", name: "Martin Martinelli",  whatsapp: "5491124722683" },
  { code: "03", name: "Nicolas Monica",     whatsapp: "5491130076655" },
  { code: "04", name: "Natalio Rodriguez",  whatsapp: "5493444462636" },
  { code: "05", name: "Daniel Mercado",     whatsapp: "5491165871522" },
  { code: "06", name: "Produlimp",          whatsapp: "5491133275841" },
  { code: "07", name: "Juan Martinelli",    whatsapp: "5491168819397" },
];

export const DEFAULT_SELLER_WHATSAPP = "5491133275841"; // Produlimp (06) - número de empresa

export const findSellerByCode = (code) => {
  if (!code) return null;
  const c = String(code).trim();
  return SELLERS.find((s) => s.code === c || s.code === c.padStart(2, "0")) || null;
};

// Aviso al vendedor de un cliente nuevo registrado con su código (link wa.me listo para enviar)
export const buildNewCustomerNotice = (customer, seller, { fromAdmin = false } = {}) => {
  if (!seller) return null;
  const intro = fromAdmin
    ? `Hola ${seller.name}! Se registró un *cliente nuevo* con tu código *${seller.code}* en la tienda Produlimp BV.`
    : `Hola ${seller.name}! Soy un *cliente nuevo* de Produlimp BV y me registré con tu código *${seller.code}*.`;
  const lines = [
    `*Nombre/Empresa:* ${customer.name || "—"}`,
    `*Email:* ${customer.email || "—"}`,
    `*Teléfono:* ${customer.phone || "—"}`,
    `*Ciudad:* ${customer.city || "—"}`,
    `*CUIT:* ${customer.cuit || "—"}`,
  ];
  const text = `${intro}\n\n${lines.join("\n")}${fromAdmin ? "" : "\n\nQuedo a disposición para coordinar mi primer pedido."}`;
  return { text, url: `https://wa.me/${seller.whatsapp}?text=${encodeURIComponent(text)}` };
};
